import { ForwardedRef, forwardRef, memo } from "react"

import { Icon } from "components"
import { ControlButton } from "modules/Call/components/ControlButton"

interface Props {
    videoOff: boolean
    lockVideoToggle: boolean
    toggleVideo(): void
    opened: boolean
}

export const VideoOutputSelector = memo(
    forwardRef(
        (
            { videoOff, toggleVideo, lockVideoToggle, opened }: Props,
            ref: ForwardedRef<HTMLButtonElement>
        ) => (
            <ControlButton
                handleToggle={toggleVideo}
                toggleOff={videoOff}
                offIndicator={<Icon type="video-off" size={32} />}
                onIndicator={<Icon type="video-on" size={32} />}
                ref={ref}
                locked={lockVideoToggle}
                opened={opened}
                arrow={true}
            />
        )
    )
)

VideoOutputSelector.displayName = "VideoOutputSelector"
